import React from "react";
import { useTranslation } from "next-i18next";

import { Wrapper, Inner, Lead, StatsGrid, FaqList } from "./style";

const SeoIntro = () => {
  const { t } = useTranslation();

  const stats = [
    { num: "23,000+", labelKey: "SEO_INTRO.STAT_STUDENTS" },
    { num: "14", labelKey: "SEO_INTRO.STAT_BRANCHES" },
    { num: "5+", labelKey: "SEO_INTRO.STAT_TEACHERS" },
    { num: "2013", labelKey: "SEO_INTRO.STAT_FOUNDED" },
  ];

  const faqs = [
    "BEST_CENTER",
    "HOW_MANY_BRANCHES",
    "TEACHERS",
    "FREE_TRIAL",
    "HOURS",
    "IELTS_X",
  ];

  return (
    <Wrapper aria-labelledby="seo-intro-title">
      <Inner>
        <Lead>
          <h2 id="seo-intro-title">{t("SEO_INTRO.TITLE")}</h2>
          <p
            dangerouslySetInnerHTML={{
              __html: t("SEO_INTRO.DESCRIPTION"),
            }}
          />
        </Lead>

        <StatsGrid>
          {stats.map((s) => (
            <li key={s.labelKey}>
              <span className="num">{s.num}</span>
              <span className="label">{t(s.labelKey)}</span>
            </li>
          ))}
        </StatsGrid>

        <FaqList>
          <h3>{t("SEO_INTRO.FAQ_TITLE")}</h3>
          {faqs.map((key) => (
            <details key={key}>
              <summary>{t(`SEO_INTRO.FAQ.${key}.Q`)}</summary>
              <p>{t(`SEO_INTRO.FAQ.${key}.A`)}</p>
            </details>
          ))}
        </FaqList>
      </Inner>
    </Wrapper>
  );
};

export default SeoIntro;
